import React from 'react';
import { trackPageView } from '../../api/analytics/google';
import { withRouter } from 'react-router-dom';

class HistoryTracker extends React.Component {
  componentDidMount() {
    trackPageView(this.props.location.pathname);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      trackPageView(nextProps.location.pathname);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(HistoryTracker);



// WEBPACK FOOTER //
// ./src/app/ui/analytics/HistoryTracker.js